import { render, staticRenderFns } from "./ProductCollections.vue?vue&type=template&id=11c8a41d&"
import script from "./ProductCollections.vue?vue&type=script&lang=js&"
export * from "./ProductCollections.vue?vue&type=script&lang=js&"
import style0 from "./ProductCollections.vue?vue&type=style&index=0&id=11c8a41d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports